import { call, put, takeLatest } from 'redux-saga/effects';
import {
	fetchReferrersSuccess,
	fetchReferrersFailure,
	approveReferrerSuccess,
	approveReferrerFailure,
	deactivateReferrerSuccess,
	deactivateReferrerFailure,
	fetchReferrers,
} from './actions';
import { fetchReferrersApi, approveReferrerApi, deactivateReferrerApi } from './api';
import { FETCH_REFERRERS, APPROVE_REFERRER, DEACTIVATE_REFERRER } from './constants';

export function* performFetchReferrers(action) {
	try {
		const result = yield call(fetchReferrersApi, action.params);
		yield put(fetchReferrersSuccess(result.data));
	} catch (err) {
		yield put(
			fetchReferrersFailure(
				err.response?.data?.error || 'Failed to fetch referrers',
			),
		);
	}
}

export function* performApproveReferrer(action) {
	try {
		yield call(approveReferrerApi, action.id);
		yield put(approveReferrerSuccess());
		yield put(fetchReferrers()); // Refresh list
	} catch (err) {
		yield put(
			approveReferrerFailure(
				err.response?.data?.error || 'Failed to approve referrer',
			),
		);
	}
}

export function* performDeactivateReferrer(action) {
	try {
		yield call(deactivateReferrerApi, action.id);
		yield put(deactivateReferrerSuccess());
		yield put(fetchReferrers()); // Refresh list
	} catch (err) {
		yield put(
			deactivateReferrerFailure(
				err.response?.data?.error || 'Failed to deactivate referrer',
			),
		);
	}
}

export default function* adminReferrersSaga() {
	yield takeLatest(FETCH_REFERRERS, performFetchReferrers);
	yield takeLatest(APPROVE_REFERRER, performApproveReferrer);
	yield takeLatest(DEACTIVATE_REFERRER, performDeactivateReferrer);
}
